import { render, staticRenderFns } from "./HeadingAdvanced.vue?vue&type=template&id=9162a3cc"
import script from "./HeadingAdvanced.vue?vue&type=script&lang=js"
export * from "./HeadingAdvanced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports